import React, { Component, Fragment } from 'react'

export default class Counter extends Component {
  constructor(props) {
    super(props);
    this.state = {
      count: 120,
      flag: true,
    }
  }

  counter = () => {
    this.setState({
      flag: false,
    })
    setInterval(() => {
      if (this.state.count === 0) {
        this.props.flagSetter();
        return;
      }
      else {
        this.setState({
          count: this.state.count - 0.5,
        })
      }
    }, 1000)
  }

  render() {
    if (this.state.flag) {
      this.counter();
    } else {
    }
    let left;
    let float;
    let right;

    left = Math.floor(this.state.count / 60);
    float = this.state.count / 60 - left;
    right = Math.round(float * 60);
    return (
      <Fragment>
        {left}:{right}
      </Fragment>
    );
  }
}